import { BlockConfig, OperationTypes, ContentTypes } from "../block-base";
import { BlockTypes } from "../block-types";

export const cdnConfig: BlockConfig = {
  displayName: "CDN",
  imagePath: "",
  isInitiator: true,
  isTerminator: true,
  isInterceptor: false,
  allowedInputTypes: new Set([BlockTypes.USER]),
  allowedOutputTypes: new Set([BlockTypes.S3_BUCKET]),
  inputCapacity: {
    total: 250000,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 250000,
        byContentType: {
          [`${ContentTypes.STATIC_MEDIA}`]: 250000,
        },
      },
    },
  },
  processingCapacity: {
    total: 250000,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 250000,
        byContentType: {
          [`${ContentTypes.STATIC_MEDIA}`]: 250000,
        },
      },
    },
  },
  purchasePrice: 500,
  sellPrice: 250,
  costPerCycle: 2,
  outputConnectorLimits: {},
};
